import { render, staticRenderFns } from "./NamePanel.vue?vue&type=template&id=472f0cfd&scoped=true"
import script from "./NamePanel.vue?vue&type=script&lang=js"
export * from "./NamePanel.vue?vue&type=script&lang=js"
import style0 from "./NamePanel.vue?vue&type=style&index=0&id=472f0cfd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472f0cfd",
  null
  
)

export default component.exports